import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import { useI18n } from '../i18n';

const NotFoundPage: React.FC = () => {
  const { t, localePath } = useI18n();
  return (
    <>
      <SeoHead
        title={t.notFound.title}
        description={t.notFound.description}
        path="/404"
        noIndex
      />
      <div className="flex items-center justify-center bg-gray-50 w-full min-h-[50vh] py-20 px-4">
        <div className="text-center lg:max-w-lg">
          <p className="text-9xl font-bold text-black opacity-10">404</p>
          <h1 className="text-2xl font-semibold mb-2">{t.notFound.heading}</h1>
          <p className="text-gray-500 mb-6">{t.notFound.body}</p>
          <Link
            to={localePath('/')}
            className="inline-block rounded-md px-6 py-3 text-white"
            style={{ backgroundColor: '#1766FF' }}
          >
            {t.notFound.backHome}
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
